/** Позиция fixed-меню под якорем с clamp к viewport (mention replace). */
export function placeMenuBelowAnchor(anchor: DOMRect, menu: DOMRect, pad = 8, gap = 4): { top: number; left: number } {
  let top = anchor.bottom + gap
  let left = anchor.left
  if (left < pad) left = pad
  if (left + menu.width > window.innerWidth - pad) {
    left = Math.max(pad, window.innerWidth - pad - menu.width)
  }
  if (top + menu.height > window.innerHeight - pad) {
    top = Math.max(pad, anchor.top - menu.height - gap)
  }
  return { top, left }
}
